import React, { useState } from "react";

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import insurancesService from "../../../services/insurances.service";
import LinkOutlinedIcon from "@material-ui/icons/LinkOutlined";
import { useEffect } from "react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "@material-ui/core";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

export default function InsurancesPage() {
  const [data, setData] = useState([]);
  const { initials } = useSelector((s) => s.app);
  const deleteItem = (item) => {
    return insurancesService.deleteInsurance(item.id);
  };

  const headerCells = useMemo(
    () => [
      {
        field: "name",
        title: "نام",
        mainField: true,
      },
      {
        field: "url",
        title: "لینک",
        // disableSort: true,
        renderer: (val) =>
          val ? (
            <Link href={val} target="_blank" rel="noreferrer">
              <LinkOutlinedIcon />
            </Link>
          ) : (
            ""
          ),
      },
      {
        field: "type",
        title: "نوع",
        // disableSort: true,
        renderer: (val) =>
          initials?.enums?.insuranceType?.find?.((t) => t.value === val)?.title,
      },
      {
        field: "isActive",
        title: "وضعیت",
        // disableSort: true,
        renderer: (val) => (val ? "فعال" : "غیر فعال"),
      },
    ],
    [initials]
  );

  useEffect(() => {
    onRefresh();
  }, []);

  const onRefresh = async () => {
    const { data, error } = await insurancesService.getInsurances();
    if (error) {
      // handleError(error);
      return;
    }
    setData(data);
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد عدسی",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        // actions={[
        //   {
        //     icon: <AddIcon />,
        //     tooltip: "ایجاد زیر خدمت",
        //     modalContent: (props) => (
        //       <FormModalContent {...props} serviceId={id} />
        //     ),
        //     modalProps: { maxWidth: "sm" },
        //   },
        // ]}
        searchKeys={defaultKeys}
        data={data}
        onRefresh={onRefresh}
        title="عدسی"
      />
      {/* <DataTable
        headCells={headerCells}
        backend={insurancesService.getInsurancesUrl}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد عدسی",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title="عدسیها"
      /> */}
    </div>
  );
}
